'use strict';

const cookie = require('./cookie-helper');

exports.getItem = key => {
  const { localStorage } = window;

  let data;

  try {
    data = localStorage.getItem(key);
  } catch (err) {
    data = cookie.getItem(key);
  }

  if (!data) {
    return null;
  }

  return JSON.parse(data);
};

exports.setItem = (key, data) => {
  const { localStorage } = window;

  const json = JSON.stringify(data);

  try {
    localStorage.setItem(key, json);
  } catch (err) {
    cookie.setItem(key, json);
  }
};
